import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";

export default function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  const { t } = useLang();
  if (user === null)
    return <div className="grid min-h-[60vh] place-items-center text-navy">{t("common.loading")}</div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
